export class OfflineDataInfo {
    constructor(sectionId, ownerId, noteId, pages = null) {
        this.Section = sectionId;
        this.Owner = ownerId;
        this.Note = noteId;
        this.Pages = pages;
    }
    ToString() {
        return `sec:${this.Section}, owner:${this.Owner}, note:${this.Note}`;
    }
}
//# sourceMappingURL=OfflineDataInfo.js.map